import { API_BASE_URL } from '../config/api';
const API_ENDPOINT = `${API_BASE_URL}/api`;

export interface LoginResponse {
  success: boolean;
  status: number;
  message: string;
  data: string; // OTP code or JWT token
}

export interface LoginRequest {
  email: string;
  fcm_token?: string | null;
}

export interface VerifyOTPRequest {
  email: string;
  otp: string;
}

export interface VerifyOTPResponse {
  success: boolean;
  status: number;
  message: string;
  data: string; // JWT token
}

export const authService = {
  // Send OTP to email for login
  async sendOTP(email: string, fcm_token?: string | null): Promise<LoginResponse> {
    try {
      const response = await fetch(`${API_ENDPOINT}/login-with-email`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, fcm_token: fcm_token || null }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data: LoginResponse = await response.json();

      // Log the response for debugging
      console.log('OTP API Response:', data);

      return data;
    } catch (error: any) {
      console.error('Error sending OTP:', error);
      throw error;
    }
  },

  // Verify OTP and get JWT token
  async verifyOTP(email: string, otp: string): Promise<VerifyOTPResponse> {
    try {
      const response = await fetch(`${API_ENDPOINT}/login-with-otp`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, otp }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      const data: VerifyOTPResponse = await response.json();

      // Log the response for debugging
      console.log('OTP Verification Response:', data);

      return data;
    } catch (error: any) {
      console.error('Error verifying OTP:', error);
      throw error;
    }
  }
};
